import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { ExternalLink, Icon, DLRichTextOutput, DLCheckbox } from 'appSrc/components/UI';
import { Popup } from 'semantic-ui-react';
import uuidv4 from 'uuid/v4';
import ContextMenu from './ContextMenu';
import { digitizeDuration } from 'appSrc/utils';
import style from './styles/style.module.css';


class ScheduleBlock extends Component {
    constructor( props ) {
        super( props );

        this.state = {
            selected: false,
        };

        this.id = `schblock-${ props.block.id || uuidv4() }`;
    }
    onEditClick = () => {
        this.props.onEditInit( this.props.block.id );
    }
    onCopyClick = () => {
        this.props.onCopyInit( this.props.block );
    }



    render() {
        const { runDate, block, errorsPresent, selectMode } = this.props;
        var st = moment( block.start_time ).tz( 'America/Chicago' );
        var et = moment( block.end_time ).tz( 'America/Chicago' );
        var video = block.video || {};
        var rowErrors = block.errors || {};
        var errorKeys = Object.keys( rowErrors );

        return (
            <div className={ style.scheduleBlock } id={ this.id } tabIndex={ this.props.tabIndex }
            data-selected={ this.props.selected } data-hidden={ block.is_hidden }
            data-live={ video.is_live }>
                <div className={ `${ style.td } ${ style.selectCell }` }
                style={ { display: selectMode ? undefined : 'none' } } >
                    <div className={ style.cellContent }>
                        <DLCheckbox value={ block.id.toString() } checked={ this.props.selected }
                        onClick={ this.props.onSelectClick } />
                    </div>
                </div>

                <div className={ `${ style.td } ${ style.errorSumCell }` }
                style={ { display: errorsPresent ? undefined : 'none' } } >
                    { errorKeys.length > 0 &&
                        <Popup className={ style.errorPopup }
                        trigger={ ( <div>
                            <Icon source='fontAwesome' icon='fas/faExclamationTriangle' />
                        </div> ) }
                        on={ ['hover', 'click'] } >
                            <Popup.Header className={ style.popupHeader }>
                                Errors:
                            </Popup.Header>
                            <Popup.Content className={ style.popupContent }>
                                { errorKeys.map( ( key ) => (
                                    <p key={ key }>{ rowErrors[ key ] }</p>
                                ) ) }
                            </Popup.Content>
                        </Popup>
                    }
                </div>

                <div className={ style.td }>
                    { runDate.format( 'MM-DD-YYYY' ) }
                </div>
                <div className={ style.td } data-error={ !!rowErrors[ 'start_time' ] }>
                    { st.format( 'hh:mmA z' ) }
                </div>
                <div className={ style.td } data-error={ !!rowErrors[ 'end_time' ] }>
                    { et.format( 'hh:mmA z' ) }
                </div>
                <div className={ style.td } data-error={ !!rowErrors[ 'video__duration' ] }>
                    { digitizeDuration( moment.duration( video.duration ) ) }
                </div>
                <div className={ style.td } data-error={ !!rowErrors[ 'category' ] }>
                    { block.category }
                </div>
                <div className={ style.td } data-error={ !!rowErrors[ 'should_persist' ] }
                style={ { textAlign: 'center' } }>
                    { block.should_persist ?
                        <Icon source='fontAwesome' icon='far/faCheckCircle' />
                        :
                        <Icon source='fontAwesome' icon='fas/faTimes' />
                    }
                </div>
                <div className={ style.td } data-error={ !!rowErrors[ 'video__uri' ] }>
                    <ExternalLink to={ video.uri }
                    title={ video.uri }>{ video.uri }</ExternalLink>
                </div>
                <div className={ style.td } data-error={ !!rowErrors[ 'video__cover_image' ] }>
                    <ExternalLink to={ video.cover_image }
                    title={ video.cover_image }>{ video.cover_image }</ExternalLink>
                </div>
                <div className={ style.td } data-error={ !!rowErrors[ 'video__title' ] }>
                    { video.title }
                </div>
                <div className={ style.td } data-error={ !!rowErrors[ 'video__pro_name' ] }>
                    { video.pro_name }
                </div>
                <div className={ style.td } data-error={ !!rowErrors[ 'video__pro_profession' ] }>
                    { video.pro_profession }
                </div>
                <div className={ style.td } data-error={ !!rowErrors[ 'video__description' ] }>
                    <DLRichTextOutput content={ video.description } />
                </div>
                <div className={ style.td } data-error={ !!rowErrors[ 'video__donation_link' ] }>
                    <ExternalLink to={ block.donation_link }
                    alt={ block.donation_link }>{ block.donation_link }</ExternalLink>
                </div>
                <div className={ style.td } data-error={ !!rowErrors[ 'video__related_content_link' ] }>
                    <ExternalLink to={ video.related_content_link }
                    alt={ video.related_content_link }>{ video.related_content_link }</ExternalLink>
                </div>
                <div className={ style.td } data-error={ !!rowErrors[ 'sponser' ] }>
                    { block.sponser }
                </div>
                <div className={ style.td } data-error={ !!rowErrors[ 'sponser_link' ] }>
                    { block.sponser_link }
                </div>
                <ContextMenu tagId={ this.id }>
                    <div className='contextMenu--option' onClick={ this.onEditClick }>Edit Block</div>
                    <div className='contextMenu--option' onClick={ this.onCopyClick }>Re-run on...</div>
                </ContextMenu>
            </div>
        );
    }
}
ScheduleBlock.defaultProps = {
    onEditInit: () => {},
    onCopyInit: () => {},
    onCheck: () => {},
    onSelectClick: () => {},
};

export default connect()( ScheduleBlock );
